import EnvUtil from '../util/EnvUtil'
import Slide from './Slide'

class Top
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Top
	// ---------------------------------------------------------------------------------------------------------

  constructor(){
    console.log('Top')

    //ヘッダー
    this.header = $('.header')

    //スライド初期化
    this.slide = new Slide()

    //スクロールハンドリング
    $(window).scroll(this.onScroll.bind(this))
    this.onScroll()
  }

  /**
   * スタート
   */
  start()
  {
    //スライド表示
    this.slide.start()
  }

  /**
   * スクロールのハンドリング
   */
  onScroll()
  {
    //スクロール量
    const scrollY = $(window).scrollTop()

    //ヘッダーの表示制御
    const fv = $('.fv')
    if(scrollY > fv.height() && this.header.hasClass('hide'))
    {
      this.header.removeClass('hide')
    }
    else if(scrollY <= fv.height() && !this.header.hasClass('hide'))
    {
      this.header.addClass('hide')
    }
  }
  
	// ---------------------------------------------------------------------------------------------------------
}

export default Top